import React from 'react';
import {
  addPathToList,
  configure_the_error_messages,
  Error_message,
  File_success_image_spec,
  General_error,
  Landscape_error,
  No_connection, permission_to_photos_two_lines,
  Transaction_failed,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';

//= ========================================================================
const Panel_T03_launch_error_messages = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'error_message_general_error',
    'error_message_no_connection',
    'error_message_transaction_failed',
    'error_message_permission_to_photos',
    'error_message_landscape_not_supported',
    'try_again',
    'reload',
    'take_me_to_settings',
  ];
  const listObject = [
    {
      subHeadline: General_error,
      fileId: 'configurations/launch/error_messages/general_error_icon',
    }, {
      subHeadline: No_connection,
      fileId: 'configurations/launch/error_messages/no_connection_icon',
    }, {
      subHeadline: Transaction_failed,
      fileId: 'configurations/launch/error_messages/transaction_failed_icon',
    }, {
      subHeadline: permission_to_photos_two_lines,
      fileId: 'configurations/launch/error_messages/permission_to_photos_icon',
    }, {
      subHeadline: Landscape_error,
      fileId: 'configurations/launch/error_messages/no_landscape_icon',
    },
  ];

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={Error_message}
      editTextList={addPathToList(editTextList, 'configurations/launch/error_messages/')}
      tooltipsTitles={globJSON.configurations.launch.screens_ordering}
      paragraph={configure_the_error_messages}
      isHollow
      language={language}
      paddingVertical={25}
    >
      <UploadMenu
        globJSON={globJSON}
        onConfigChanged={onConfigChanged}
        headline={Upload_assets}
        details={File_success_image_spec}
        listObject={listObject}
      />
    </FullPagePanel>
  );
};

export default Panel_T03_launch_error_messages;
